<template>
  <edit-module
    ref="editModule"
    :saving="saving"
    :disabled="!hasChanges"
    @submit="handleSave"
    @expand="toggleOpen"
  >
    <template #header>
      <div>
        <detail-label
          label="Service Category:"
          :value="serviceCategoryName"
        ></detail-label>
      </div>
    </template>
    <template #body>
      <div v-if="open">
        <service-category-form
          v-model="formData.service_category_id"
        ></service-category-form>
        <change-summary
          :changes="changes"
          :original="originalValues"
        ></change-summary>
      </div>
    </template>
  </edit-module>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getObjDiff, getProperty } from "@/lib/helpers.js";

import DetailLabel from "@/components/DetailLabel.vue";
import EditModule from "@/components/EditModule.vue";
import ChangeSummary from "../../ChangeSummary.vue";
import ServiceCategoryForm from "../../forms/ServiceCategoryForm.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    EditModule,
    DetailLabel,
    ServiceCategoryForm,
    ChangeSummary
  },
  props: {
    appointment: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      open: false,
      saving: false,
      formData: {
        service_category_id: getProperty(
          this.appointment.service_category,
          "id"
        )
      }
    };
  },
  computed: {
    ...mapState({
      selectedServiceCategory({ serviceCategories }) {
        return serviceCategories.find(
          (sc) => sc.id === this.formData.service_category_id
        );
      }
    }),
    serviceCategoryName() {
      return getProperty(this.appointment.service_category, "name") || "--";
    },
    changes() {
      return getObjDiff(this.originalValues, this.formData);
    },
    originalValues() {
      return {
        service_category_id: getProperty(
          this.appointment.service_category,
          "id"
        )
      };
    },
    hasChanges() {
      return Object.keys(this.changes).length > 0;
    }
  },
  watch: {
    appointment(newValue, oldValue) {
      if (newValue.service_category !== oldValue.service_category) {
        this.formData = {
          service_category_id: getProperty(newValue.service_category, "id")
        };
      }
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  methods: {
    ...mapActions(["updateAppointment"]),
    handleSave() {
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          const link = this.appointment.links.update;
          if (link) {
            this.saving = true;
            this.updateAppointment({ link, data: this.formData })
              .then(() => {
                window.notify.success("Appointment updated successfully!");
                this.$refs.editModule?.handleClose();
              })
              .finally(() => (this.saving = false));
          } else {
            window.notify.error("Unable to edit this appointment");
          }
        }
      });
    },
    resetForm() {
      this.formData = {
        service_category_id: getProperty(
          this.appointment.service_category,
          "id"
        )
      };
    },
    toggleOpen() {
      this.open = !this.open;
      if (!this.open) {
        this.resetForm();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
